<template>
  <main class="retoure-und-kuendigung">
    <Breadcrumb :items="breadcrumb" />
    <div class="grid grid--center">
      <div class="grid__item grid__item-12 grid__item--spacing-2">
        <Heading
          spaces-bottom
          class="text--center"
        >
          {{ data.pageHeading }}
        </Heading>
        <Paragraph
          class="text text--center"
          v-html="data.pageIntroduction"
        ></Paragraph>
      </div>
      <TabGroup
        :tabs="data.tabsData"
        :class="'grid__item grid__item--12'"
      >
        <TabGroupEntry
          slot="retoure"
          class="grid grid--center"
        >
          <div class="grid__item grid__item--8">
            <div class="grid grid--center">
              <TextImage
                v-for="(retoure, i) in data.textImageData?.retoure"
                :key="i"
                :text-image-data="retoure"
                class="grid__item grid__item-12 grid__item--m-6 grid__item--l-5"
              />
            </div>
          </div>
        </TabGroupEntry>
        <TabGroupEntry
          slot="lieferstatus"
          class="grid grid--center"
        >
          <div class="grid__item grid__item--8">
            <div class="grid grid--center">
              <TextImage
                v-for="(retoure, i) in data.textImageData?.lieferstatus"
                :key="i"
                :text-image-data="retoure"
                class="grid__item grid__item-12 grid__item--m-6 grid__item--l-5"
              />
            </div>
          </div>
        </TabGroupEntry>
      </TabGroup>
    </div>
  </main>
</template>

<script setup lang="ts">
import { ref } from 'vue';
import { useRuntimeConfig, useLazyAsyncData, useRoute } from '#imports';
import Breadcrumb from '@/components/breadcrumb.vue';
import { contentDataFor } from '@/lib/content-data-factory';
import TabGroup from '@/components/tab-group.vue';
import TabGroupEntry from '@/components/tab-group-entry.vue';
import TextImage from '@/components/text-image.vue';
import { Heading, Paragraph } from '@i22-td-smarthome/component-library';
import { Track } from '~/helpers/page-tracking';
import { getHeader } from '~/helpers/page-header-compositon';

const $config = useRuntimeConfig();
const $route = useRoute();

const { data } = useLazyAsyncData('lieferstatus-und-retoure', async () =>
  contentDataFor('hilfe/lieferstatus-und-retoure.json', $config)
);

Track({ page_type: 'theme.solution' });

getHeader({
  title: ref('Lieferstatus und Retoure'),
  description: ref(
    'Du möchtest Dich über den Lieferstatus Deiner bestellten Produkte informieren? Bitte wähle dazu, über welche Produkte Du Dich informieren möchtest!'
  ),
  ogImage: ref(
    '/content/content-images/lieferstatus-retoure/retoure/e52539d1c154fc00308c968aed755377/retoure-retoure.png'
  ),
});

const breadcrumb = ref([
  {
    label: 'Lieferstatus & Retoure',
    to: $route.path,
  },
]);
</script>

<style lang="scss" scoped>
@use 'assets/base' as *;

.retoure-und-kuendigung {
  h1 {
    margin-top: 2.5 * $grid-base;
  }

  .tab-group {
    .text-image__image {
      img {
        display: inline-block;
      }
    }
  }
}
</style>
